import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { config } from 'config/config';
import React from 'react';
import styles from './AddonsCard.module.css';

interface AddonCardProps {
  title: string;
  description: string;
  price: number | undefined;
  isChecked: boolean | undefined;
  id: string;
  numberOfDays?: number;
  onCheck: () => void;
  PayNowDiscAmount?: string | number;
  isCompulsoryOnRental?: boolean;
}

export const AddonCard: React.FC<AddonCardProps> = ({
  title,
  description,
  price,
  isChecked,
  id,
  onCheck,
  numberOfDays,
  isCompulsoryOnRental,
}) => {
  const style = {
    boxShadow: '-3px -3px 28px 0px #0670B1AB inset',
    background: 'linear-gradient(180deg, #EFF9FF 0%, #F2FAFF 100%)',
    display: 'block',
    height: 'auto',
    minHeight: '184px',
    maxHeight: '184px',
  };

  const activeBorder = {
    border: '4px solid #fff',
  };

  return (
    <Card
      style={
        isChecked
          ? { ...activeBorder, borderRadius: '10px' }
          : { border: 'unset', borderRadius: '10px' }
      }
      sx={{
        position: 'relative',
        cursor: isCompulsoryOnRental ? 'default' : 'pointer',
      }}
      onClick={isCompulsoryOnRental ? undefined : onCheck}
    >
      <CardContent style={style}>
        <Box
          className="checkbox-container"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography variant="h6" sx={{ textAlign: 'left !important' }}>
            {title}
          </Typography>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={onCheck}
            id={id}
          />
          <label htmlFor={id}></label>
        </Box>
        <Typography className={styles.checkboxDescription}>
          {description}
        </Typography>
        <Box
          sx={{
            position: 'absolute',
            width: '90%',
            bottom: '20px',
          }}
        >
          <Divider sx={{ backgroundColor: 'lightgray', height: '1px' }} />
          <Typography className="payment-text" key={id}>
            <span className="currency-tag">{config.CURRENCY}</span>
            <span className="price">{price.toFixed(2)}</span>

            <span className="booking-duration">
              {numberOfDays > 1
                ? `for ${numberOfDays} days`
                : `for ${numberOfDays} day`}
            </span>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
